import React from 'react';
import moment from 'moment';
import Slider from 'react-slick';
import Icon from '../graphics/Icon';
import Logo from '../graphics/Logo';
import MobileNews from './MobileNews';
import $ from 'jquery';
import styled from 'styled-components';

const LogoWrapper = styled.div`
  padding: 15px;
`;
const MobileMenu = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  background: #0066FF;
  width: 100%;
  height: 100%;
  opacity: ${props => props.opacity};
  z-index: 255;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  // align-items: center;
`;
const Menu = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: left;
  flex-grow: 2;
  width: 55%;
  margin: 15px 0 0 25%;
`;
const Link = styled.div`
  color: #fff;
  font-weight: 700;
  font-size: 36px;
  cursor: pointer;
  margin: 8px 5px;
`;
const Social = styled.div`
  margin-top: 13px;
  .icon {
    margin: 0 8px;
  }
  g {
    fill: #fff;
  }
  span {
    cursor: pointer;
  }
`;
const Footer = styled.div`
  text-align: center;
  color: #fff;
  font-size: 14px;
  width: 100%;
  margin-bottom: 15px;
`;
const HTB = styled.div`
  display: inline-block;
  margin-right: 10px;
  vertical-align: middle;
`;

function openWindow(network) {
  var getUrl = window.location, title, twitterText, fbText, googleText;
  var base = process.env.REACT_APP_PUBLIC_URL;
  var url = process.env.REACT_APP_PUBLIC_URL + getUrl.pathname;
  var fbID = process.env.REACT_APP_FACEBOOK_APP_ID;
  var hashtag = 'HealTheBay';
  twitterText = 'See the latest @beachreportcard water quality grades for your favorite beach.';
  title = 'Beach Report Card';
  fbText = 'See the latest water quality grades for your favorite beach. #HealTheBay';
  googleText = 'See the latest Beach Report Card water quality grades for your favorite beach. #HealTheBay';

  const link = (n) => ({
    'twitter': encodeURI('https://twitter.com/intent/tweet?url=' + url + '&text=' + twitterText + '&hashtags=' + hashtag),
    'gplus': encodeURI('https://plus.google.com/share?url=' + url + '&text=' + googleText + '&hl=en-US'),
    'facebook': encodeURI('https://www.facebook.com/dialog/share?app_id=' + fbID + '&display=popup&quote=' + fbText + '&href=' + base + '&redirect_uri=' + url)
  })[n];
  window.open(link(network), '_blank', "toolbar=0,status=0,width=700,height=500");
}
const mobileMenu = (props) => {
  return (
    <MobileMenu opacity={props.opacity}>
      <LogoWrapper><Logo logo="brc2" /></LogoWrapper>
      <Menu>
        <Link onClick={props.showHelp}>Help</Link>
        <Link>Share</Link>
        <Social>
          <span onClick={() => openWindow('twitter')}><Icon name="twitter" /></span>
          <span onClick={() => openWindow('gplus')}><Icon name="gplus" /></span>
          <span onClick={() => openWindow('facebook')}><Icon name="facebook" /></span>
        </Social>
      </Menu>
      <MobileNews results={props.results} news={props.news} />
      <Footer>
        <HTB><Logo logo="htb" /></HTB>
        &copy; {(new Date().getFullYear())} Beach Report Card
      </Footer>
    </MobileMenu>
  );
}

export default mobileMenu;


// WEBPACK FOOTER //
// ./src/components/static/MobileMenu.js